export default class PromoLine {
    static init() {
        const block = document.querySelector('.promo__carousel')

        if (block) {
            new PromoLine(block)
        }
    }

    constructor(block) {
        const descriptionBlocks = block.querySelectorAll('.item__description')

        descriptionBlocks.forEach(el => {
            if (!el.textContent) {
                el.style.display = 'none'
            }

        })
    }
}
